<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <div>
        <v-btn @click="$router.go(-1)" text class="pl-0">
          <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
          <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
        </v-btn>
      </div>
      <div v-if="!loadingTransaction">
        <v-card-title
          class="pa-0"
          style="display: flex; text-align: center; justify-content: center"
        >
          <h3 class="font-weight-bold my-4">Detalle de {{ "conversión" }}</h3>
        </v-card-title>
        <v-card-text class="pb-5 px-10">
          <div
            class="my-8"
            style="display: flex; justify-content: space-around; flex-direction: column"
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <div style="color: black; font-size: 20px">Tipo</div>
                <div style="color: black; font-size: 22px; font-weight: bold">
                  {{
                    conversion.sTransactionType == "e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a"
                      ? "Forex"
                      : "Forward"
                  }}
                </div>
              </div>
              <div>
                <div style="color: black; font-size: 20px; text-align: center">Monto</div>
                <div style="color: black; font-size: 22px; font-weight: bold">
                  {{ "$ " + formatMoney(conversion.dDesAmount) + " MXN" }}
                </div>
              </div>
              <template v-if="conversion.invoice">
                <div v-if="conversion.invoice.length > 0">
                  <div style="color: black; font-size: 20px">Profit</div>
                  <div style="color: green; font-size: 22px; font-weight: bold">
                    {{ formatMoney(conversion.percentProfit) + "%" }}
                  </div>
                  <div style="color: green; font-size: 22px; font-weight: bold">
                    {{ formatMoney(conversion.dollarProfit) + " USD" }}
                  </div>
                </div>
                <div v-else></div>
              </template>
            </div>
          </div>
          <div
            class="my-8"
            style="display: flex; justify-content: space-around; flex-direction: column"
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <div style="color: black; font-size: 20px" v-if="conversion.invoice">
                  Supplier:
                  <span
                    style="color: black; font-size: 22px; font-weight: bold"
                    v-if="conversion.invoice.length > 0"
                  >
                    {{ conversion.invoice[0].invoice.paymentsRecipent[0].sName }}</span
                  >
                </div>
              </div>
              <div>
                <div style="color: black; font-size: 20px">
                  Exchange rate:
                  <span style="color: black; font-size: 22px; font-weight: bold">
                    {{ "$ " + conversion.dExchangeRate + " MXN" }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="my-8"
            style="display: flex; justify-content: space-around; flex-direction: column"
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <div style="color: black; font-size: 20px">
                  Fecha de creación:
                  <span style="color: black; font-size: 22px; font-weight: bold">
                    {{ formatDate(conversion.created_at) }}</span
                  >
                </div>
              </div>
              <div>
                <div
                  style="color: black; font-size: 20px"
                  v-if="conversion.dForwardTransactionDate"
                >
                  Fecha de cumplimiento:
                  <span style="color: black; font-size: 22px; font-weight: bold">
                    {{ formatDate(conversion.dForwardTransactionDate) }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="mb-8">
            <div class="mb-4" style="color: black; font-size: 22px; font-weight: bold">
              Porcentaje de la conversión utilizado
            </div>
            <v-progress-linear height="45" :value="conversion.percent">
              <strong style="color: white">{{ formatMoney(conversion.percent) }}%</strong>
            </v-progress-linear>
          </div>
          <v-card elevation="5" class="pa-4">
            <div
              class="mb-6"
              style="
                display: flex;
                justify-content: space-around;
                color: black;
                font-size: 22px;
                font-weight: bold;
                align-items: center;
              "
            >
              <div>Facturas asignadas</div>
              <v-spacer></v-spacer>
              <v-btn
                style="
                  text-align: center;
                  color: #0075B8;
                  font-size: 15px;
                  background-color: transparent;
                  font-family: montserrat-bold;
                  font-weight: 600;
                  line-height: 24px;
                  text-transform: capitalize;
                  word-wrap: break-word;
                  border-radius: 5px;
                  border: 1px solid #0075B8;
                  padding: 8px 16px;
                "
                elevation="0"
                @click="updateInvoice()"
                class="ml-2"
                :disabled="loadingTransaction"
              >
                <v-icon left>mdi mdi-file-document-plus-outline</v-icon>
                Editar Facturas Asignadas
              </v-btn>
            </div>
            <v-data-table
                item-key="sInvoiceId"
                :headers="headersInvoices"
                disable-sort
                :items="conversion.invoice"
              >
                <template v-slot:item.data-table-select="{ item, select }">
                  <v-checkbox
                    :input-value="isSelected(item)"
                    @click="toggleSelect(item, select)"
                    :disabled="item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                  ></v-checkbox>
                </template>
                <template v-slot:item.sName="{ item }">
                  <!-- <h4 style="font-family: 'Montserrat', sans-serif">{{ this.item }}</h4> -->
                </template>
                <template v-slot:item.dDueDate="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">
                    {{ formatDate(item.invoice.dDueDate) }}
                  </h4>
                </template>
                <template v-slot:item.dPurchaseDate="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">
                    {{ formatDate(item.invoice.dPurchaseDate) }}
                  </h4>
                </template>
                <template v-slot:item.sInvoice="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">{{ item.invoice.sInvoice }}</h4>
                </template>
                <template v-slot:item.sId="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">{{ item.invoice.sId }}</h4>
                </template>
                <template v-slot:item.dTotalAmount="{ item }">
                  <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                    $ {{ formatMoney(item.dAmount) }} MXN
                  </h4>
                </template>
                <template v-slot:item.dRateProtection="{ item }">
                  <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                    $ {{ formatMoney(item.invoice.dRateProtection) }} MXN
                  </h4>
                </template>
                <template v-slot:item.dProfitPercentage="{ item }">
                  <h4
                    :style="{ color: item.dProfitPercentage < 0 ? 'red' : 'green' }"
                    style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                  >
                    {{ formatMoney(item.invoice.dProfitPercentage) + "%" }}
                  </h4>
                </template>
                <template v-slot:item.dCurrencyGain="{ item }">
                  <h4
                    :style="{ color: item.invoice.dCurrencyGain < 0 ? 'red' : 'green' }"
                    style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                  >
                    $ {{ formatMoney(item.invoice.dCurrencyGain) }} USD
                  </h4>
                </template>
                <template v-slot:item.sStatusId="{ item }">
                  <v-chip
                    v-if="item.invoice.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                    class="ma-2"
                    color="primary"
                    outlined
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.invoice.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'"
                    class="ma-2"
                    outlined
                    color="green"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Assigned" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.invoice.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'"
                    class="ma-2"
                    outlined
                    color="#193D6E"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.invoice.sStatusId == '63b83525-e0ff-4d52-821a-df20611cb4a3'"
                    class="ma-2"
                    outlined
                    color="red"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Parcial" }}</h4>
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div style="display: flex; align-items: center; justify-content: center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="goToInvoice(item)"
                          :disabled="loading"
                          v-bind="attrs"
                          v-on="on"
                          icon
                          color="black"
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver detalle</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="openDialogDeleteInvoice(item)"
                          :disabled="loading || true"
                          v-bind="attrs"
                          v-on="on"
                          icon
                          color="black"
                        >
                          <v-icon>mdi-cash-sync</v-icon>
                        </v-btn>
                      </template>
                      <span>Pagar factura</span>
                    </v-tooltip>
                  </div>
                </template>
            </v-data-table>
          </v-card>
          <div style="display: flex; justify-content: end; margin-top: 20px">
            <v-spacer></v-spacer>
            <v-btn
              class="button-save white--text"
              style="max-width: 200px"
              elevation="0"
              color="#0075B8"
              :disabled="conversion.percent == 0 || loadingTransaction"
              @click="openPayInvoices(conversion)"
              >Pagar facturas
            </v-btn>
          </div>
        </v-card-text>
      </div>
      <v-skeleton-loader v-else class="mx-auto" type="image"></v-skeleton-loader>
    </v-container>
    <v-dialog v-model="dialogSendPay" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-container class="mt-1">
          <div v-if="step == 1">
            <v-card-title
              style="display: flex; text-align: center; justify-content: center"
            >
              <span class="title font-weight-bold text-textblack">
                Selecciona el contacto al que quieres enviar el pago.
              </span>
            </v-card-title>
            <v-card-text class="py-0">
              <div class="mb-4">
                <v-list rounded v-if="!isLoadingSuppliers">
                  <v-subheader style="font-size: 24px; color: black"
                    >Contactos</v-subheader
                  >
                  <v-list-item-group
                    color="#0075B8"
                    style="height: 300px; overflow: scroll; overflow-x: auto"
                    v-model="selectedSupplier"
                  >
                    <v-list-item
                      style="border: 1px solid grey"
                      class="mb-4"
                      v-for="(item, i) in suppliers"
                      :key="i"
                      @click="selectSupplier(item)"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="'mdi-account'"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.sName"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-skeleton-loader
                  v-else
                  class="mx-auto"
                  type="image"
                ></v-skeleton-loader>
              </div>
            </v-card-text>
            <div style="display: flex; justify-content: end; margin-top: 20px">
              <v-btn elevation="0" class="button-cancel mon-regular" @click="cancel()">
                {{ texts.modalForm.cancel }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                class="button-save"
                style="max-width: 200px"
                elevation="0"
                color="#0075B8"
                @click="step = 2"
                >Continuar
              </v-btn>
            </div>
          </div>
          <div v-if="step == 2">
            <v-card-title
              class="pa-0"
              style="display: flex; text-align: center; justify-content: center"
            >
              <span class="title font-weight-bold text-textblack"> Detalle de pago </span>
            </v-card-title>
            <v-card-text class="py-6 pb-0" v-if="!loading">
              <div
                class="mb-8"
                style="
                  display: flex;
                  justify-content: space-around;
                  background-color: #e2e8f0;
                  flex-direction: column;
                  width: 600px;
                "
              >
                <div
                  class="pt-6 pb-4 px-10"
                  style="display: flex; justify-content: space-between"
                >
                  <div class="" style="color: black; font-size: 16px">
                    Nombre del cliente:
                  </div>
                  <div class="" style="color: black; font-size: 22px; font-weight: bold">
                    {{ conversionPayment.detail.supplier.sName }}
                  </div>
                </div>
                <div
                  class="py-4 px-10"
                  style="display: flex; justify-content: space-between"
                >
                  <div class="" style="color: black; font-size: 16px">Número CLABE:</div>
                  <div class="" style="color: black; font-size: 22px; font-weight: bold">
                    {{ "********" + sAccountNumber }}
                  </div>
                </div>
                <div
                  class="py-4 px-10"
                  style="display: flex; justify-content: space-between"
                >
                  <div class="" style="color: black; font-size: 16px">
                    Cantidad a enviar:
                  </div>
                  <div class="" style="color: black; font-size: 22px; font-weight: bold">
                    ${{ formatMoney(conversionPayment.detail.conversion[0].dAmount) }}
                    USD
                  </div>
                </div>
                <div
                  class="py-4 px-10"
                  style="display: flex; justify-content: space-between"
                >
                  <div class="" style="color: black; font-size: 16px">
                    El destinatario recibirá:
                  </div>
                  <div class="" style="color: black; font-size: 22px; font-weight: bold">
                    ${{ formatMoney(conversionPayment.detail.conversion[0].dDesAmount) }}
                    MXN
                  </div>
                </div>
                <div
                  class="py-4 px-10"
                  style="display: flex; justify-content: space-between"
                >
                  <div class="" style="color: black; font-size: 16px">
                    Tipo de cambio:
                  </div>
                  <div class="" style="color: black; font-size: 22px; font-weight: bold">
                    ${{
                      formatMoney(conversionPayment.detail.conversion[0].dExchangeRate)
                    }}
                    USD
                  </div>
                </div>
                <div
                  class="py-4 px-10"
                  style="display: flex; justify-content: space-between"
                  v-if="conversionPayment.detail.conversion[0].invoice.length > 0"
                >
                  <div class="" style="color: black; font-size: 16px">
                    Factura a pagar:
                  </div>
                  <div
                    class=""
                    style="
                      color: black;
                      font-size: 22px;
                      font-weight: bold;
                      display: flex;
                      gap: 10px;
                    "
                  >
                    <div
                      v-for="(item, idx) in conversionPayment.detail.conversion[0]
                        .invoice"
                    >
                      {{ item.invoice.sInvoice }}
                    </div>
                  </div>
                </div>
                <div
                  class="py-4 pb-6 px-10"
                  style="display: flex; justify-content: space-between"
                >
                  <div class="" style="color: black; font-size: 16px">
                    Fecha de envío:
                  </div>
                  <div class="" style="color: black; font-size: 22px; font-weight: bold">
                    {{ formatDate(today) }}
                  </div>
                </div>
                <div
                  class="py-4 pb-6 px-10"
                  style="display: flex; justify-content: space-between"
                >
                  <v-textarea
                    name="input-7-1"
                    label="Concepto de pago"
                    v-model="comment"
                    no-resize
                  ></v-textarea>
                </div>
              </div>
            </v-card-text>
            <div v-else style="display: flex; justify-content: center">
              <v-progress-circular indeterminate color="amber"></v-progress-circular>
            </div>
            <div style="display: flex; justify-content: end; margin-top: 20px">
              <v-btn 
                elevation="0" 
                class="button-cancel mon-regular" 
                @click="cancel()"
                :disabled="loading"
              >
                {{ texts.modalForm.cancel }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                class="button-save white--text"
                style="max-width: 200px"
                elevation="0"
                color="#0075B8"
                :disabled="!comment || loading"
                @click="sendPayment()"
                >Confirmar pago
              </v-btn>
            </div>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSendPayOfInvoice" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="step" alt-labels elevation="0">
          <v-stepper-header
            color="#193D6E"
            class="mt-5 mr-15 ml-15"
            elevation="0"
            style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
          >
            <v-stepper-step :complete="step > 1" step="1" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2" color="#193D6E"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Paso 1: Detalle de pago -->
            <v-stepper-content step="1" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack"> Detalle de pago </span>
                </v-card-title>
                <v-card-text class="py-6 pb-0" v-if="!loading">
                  <div
                    class="mb-8"
                    style="
                      display: flex;
                      justify-content: space-around;
                      background-color: #e2e8f0;
                      flex-direction: column;
                      width: 600px;
                    "
                  >
                    <div
                      class="pt-6 pb-4 px-10"
                      style="display: flex; justify-content: space-between"
                    >
                      <div class="" style="color: black; font-size: 16px">
                        Nombre del cliente:
                      </div>
                      <div class="" style="color: black; font-size: 22px; font-weight: bold">
                        {{ conversionPayment.detail.supplier.sName }}
                      </div>
                    </div>
                    <div
                      class="py-4 px-10"
                      style="display: flex; justify-content: space-between"
                    >
                      <div class="" style="color: black; font-size: 16px">Número CLABE:</div>
                      <div class="" style="color: black; font-size: 22px; font-weight: bold">
                        {{ "********" + sAccountNumber }}
                      </div>
                    </div>
                    <div
                      class="py-4 px-10"
                      style="display: flex; justify-content: space-between"
                    >
                      <div class="" style="color: black; font-size: 16px">
                        El destinatario recibirá:
                      </div>
                      <div class="" style="color: black; font-size: 22px; font-weight: bold">
                        ${{ formatMoney(conversionPayment.detail.dAmount) }} MXN
                      </div>
                    </div>
                    <div
                      class="py-4 px-10"
                      style="display: flex; justify-content: space-between"
                    >
                      <div class="" style="color: black; font-size: 16px">
                        Tipo de cambio:
                      </div>
                      <div class="" style="color: black; font-size: 22px; font-weight: bold">
                        ${{
                          formatMoney(conversionPayment.detail.conversion[0]?.dExchangeRate)
                        }}
                        MXN
                      </div>
                    </div>
                    <div
                      class="py-4 px-10"
                      style="display: flex; justify-content: space-between"
                      v-if="conversionPayment.detail.conversion[0]?.invoice.length > 0"
                    >
                      <div class="" style="color: black; font-size: 16px">
                        Factura a pagar:
                      </div>
                      <div
                        class=""
                        style="
                          color: black;
                          font-size: 22px;
                          font-weight: bold;
                          display: flex;
                          gap: 10px;
                        "
                      >
                        <div
                          v-for="(item, idx) in conversionPayment.detail.conversion[0].invoice"
                        >
                          {{ item.invoice.sInvoice }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="py-4 pb-6 px-10"
                      style="display: flex; justify-content: space-between"
                    >
                      <div class="" style="color: black; font-size: 16px">
                        Fecha de envío:
                      </div>
                      <div class="" style="color: black; font-size: 22px; font-weight: bold">
                        {{ formatDate(today) }}
                      </div>
                    </div>
                    <div
                      class="py-4 pb-6 px-10"
                      style="display: flex; justify-content: space-between"
                    >
                      <v-textarea
                        name="input-7-1"
                        label="Concepto de pago"
                        v-model="comment"
                        no-resize
                      ></v-textarea>
                    </div>
                  </div>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <div v-if="!loading" style="display: flex; justify-content: end; margin-top: 20px">
                  <v-btn
                    elevation="0"
                    class="button-cancel mon-regular"
                    @click="cancelDialog()"
                    :disabled="loading"
                  >
                    {{ texts.modalForm.cancel }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="button-save"
                    style="max-width: 200px; color: #FFF; background-color: #193D6E;"
                    elevation="0"
                    :disabled="!comment || loading"
                    @click="sendVerification(2)"
                    >Continuar
                  </v-btn>
                </div>
              </v-container>
            </v-stepper-content>

            <!-- Paso 2: Verificación OTP -->
            <v-stepper-content step="2" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center;">
                  <span class="title font-weight-bold text-textblack">{{ texts.twoFactor.twoFactor }}</span>
                </v-card-title>
                <v-card-text class="py-6 pb-0">
                  <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row; width: 600px">
                    <div>
                      <v-otp-input v-model="otp" length="6" type="number"></v-otp-input>
                      <p style="font-size: 14px; font-weight: 500;">{{ texts.twoFactor.enterCode }}</p>
                    </div>
                  </div>
                </v-card-text>
                <div style="display: flex; justify-content: end; margin-top: 20px;">
                  <v-btn elevation="0" class="button-cancel mon-regular" @click="step = 1" :disabled="loading">{{ texts.modalForm.cancel }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn class="button-save"
                    style="max-width: 200px; color: #FFF; background-color: #193D6E;"
                    elevation="0"
                    :disabled="otp.length < 6 || loading"
                    color="#193D6E"
                    @click="sendPayment()">
                    {{ texts.modalForm.confirmPay }}
                  </v-btn>
                </div>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetailConversion" max-width="1200">
      <v-card v-if="!loadingTransaction">
        <v-card-title
          class="pa-0"
          style="display: flex; text-align: center; justify-content: center"
        >
          <h3 class="font-weight-bold my-4">Detalle de {{ "conversión" }}</h3>
        </v-card-title>
        <v-card-text class="pb-5 px-10">
          <div
            class="my-8"
            style="display: flex; justify-content: space-around; flex-direction: column"
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <div style="color: black; font-size: 20px">Tipo</div>
                <div style="color: black; font-size: 22px; font-weight: bold">
                  {{
                    conversion.sTransactionType == "e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a"
                      ? "Forex"
                      : "Forward"
                  }}
                </div>
              </div>
              <div>
                <div style="color: black; font-size: 20px; text-align: center">Monto</div>
                <div style="color: black; font-size: 22px; font-weight: bold">
                  {{ "$ " + formatMoney(conversion.dDesAmount) + " MXN" }}
                </div>
              </div>
              <template v-if="conversion.invoice">
                <div v-if="conversion.invoice.length > 0">
                  <div style="color: black; font-size: 20px">Profit</div>
                  <div style="color: green; font-size: 22px; font-weight: bold">
                    {{ formatMoney(conversion.percentProfit) + "%" }}
                  </div>
                  <div style="color: green; font-size: 22px; font-weight: bold">
                    {{ formatMoney(conversion.dollarProfit) + " USD" }}
                  </div>
                </div>
                <div v-else></div>
              </template>
            </div>
          </div>
          <div
            class="my-8"
            style="display: flex; justify-content: space-around; flex-direction: column"
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <div style="color: black; font-size: 20px" v-if="conversion.invoice">
                  Supplier:
                  <span
                    style="color: black; font-size: 22px; font-weight: bold"
                    v-if="conversion.invoice.length > 0"
                  >
                    {{ conversion.invoice[0].invoice.paymentsRecipent[0].sName }}</span
                  >
                </div>
              </div>
              <div>
                <div style="color: black; font-size: 20px">
                  Exchange rate:
                  <span style="color: black; font-size: 22px; font-weight: bold">
                    {{ "$ " + conversion.dExchangeRate + " MXN" }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="my-8"
            style="display: flex; justify-content: space-around; flex-direction: column"
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <div style="color: black; font-size: 20px">
                  Fecha de creación:
                  <span style="color: black; font-size: 22px; font-weight: bold">
                    {{ formatDate(conversion.created_at) }}</span
                  >
                </div>
              </div>
              <div>
                <div
                  style="color: black; font-size: 20px"
                  v-if="conversion.dForwardTransactionDate"
                >
                  Fecha de cumplimiento:
                  <span style="color: black; font-size: 22px; font-weight: bold">
                    {{ formatDate(conversion.dForwardTransactionDate) }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="mb-8">
            <div class="mb-4" style="color: black; font-size: 22px; font-weight: bold">
              Porcentaje de la conversión utilizado
            </div>
            <v-progress-linear height="45" :value="conversion.percent">
              <strong style="color: white">{{ formatMoney(conversion.percent) }}%</strong>
            </v-progress-linear>
          </div>
          <div>
            <div
              class="mb-6"
              style="
                display: flex;
                justify-content: space-around;
                color: black;
                font-size: 22px;
                font-weight: bold;
              "
            >
              <div>Facturas asignadas</div>
              <v-spacer></v-spacer>
              <v-autocomplete
                label="Nombre del proveedor*"
                required
                :items="suppliers"
                :disabled="conversion.invoice.length > 0"
                class="pt-0 mt-0"
                v-if="active"
                item-value="sPaymentRecipientId"
                item-text="sName"
                @change="getInvoicesWithSupplier(sPaymentRecipientId)"
                v-model="sPaymentRecipientId"
                :rules="[rules.required]"
              ></v-autocomplete>
              <v-spacer></v-spacer>
              <v-btn
                style="
                  text-align: center;
                  color: #0075B8;
                  font-size: 15px;
                  background-color: transparent;
                  font-family: montserrat-bold;
                  font-weight: 600;
                  line-height: 24px;
                  text-transform: capitalize;
                  word-wrap: break-word;
                  border-radius: 5px;
                  border: 1px solid #0075B8;
                  padding: 8px 16px;
                "
                elevation="0"
                @click="updateInvoice()"
                class="ml-2"
                :disabled="conversion.percent == 100 || loadingTransaction"
              >
                <v-icon left>mdi mdi-file-document-plus-outline</v-icon>
                Agregar facturas
              </v-btn>
            </div>
            <div
              v-if="conversion.invoice"
              style="display: flex; justify-content: flex-start; gap: 30px"
            >
              <v-card
                :disabled="active"
                class="mb-4 mx-4"
                style="width: 340px"
                v-for="(item, idx) in conversion.invoice"
                :key="idx"
              >
                <v-card-title>
                  <h3>Invoice: {{ item.invoice.sInvoice }}</h3>
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openInvoice(item)"
                        :disabled="false"
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="black"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Modificar factura</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="deleteInvoice(item)"
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="red"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar factura de la conversión</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text>
                  <div
                    class="mt-8"
                    style="
                      display: flex;
                      justify-content: space-around;
                      flex-direction: column;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        align-items: flex-start;
                        flex-direction: column;
                      "
                    >
                      <div class="my-2">
                        <div style="color: black; font-size: 20px">Monto</div>
                        <div style="color: black; font-size: 22px; font-weight: bold">
                          {{ "$ " + formatMoney(item.invoice.dTotalAmount) + "MXN" }}
                        </div>
                      </div>
                      <div class="my-2">
                        <div style="color: black; font-size: 20px">Fecha de compra</div>
                        <div style="color: black; font-size: 22px; font-weight: bold">
                          {{ formatDate(item.invoice.dPurchaseDate) }}
                        </div>
                      </div>
                      <div class="my-2">
                        <div style="color: black; font-size: 20px; text-align: center">
                          Exchange rate protected
                        </div>
                        <div style="color: black; font-size: 22px; font-weight: bold">
                          {{ "$ " + formatMoney(item.invoice.dRateProtection) + " MXN" }}
                        </div>
                      </div>
                      <div
                        class="my-2"
                        style="display: flex; width: 100%; justify-content: space-around"
                      >
                        <div>
                          <div class="mb-2" style="color: black; font-size: 20px">
                            Profit (%)
                          </div>
                          <div
                            :style="{
                              color: item.invoice.dProfitPercentage < 0 ? 'red' : 'green',
                            }"
                            style="color: black; font-size: 22px; font-weight: bold"
                          >
                            {{ item.invoice.dProfitPercentage + "%" }}
                          </div>
                        </div>
                        <div>
                          <div class="mb-2" style="color: black; font-size: 20px">
                            Profit
                          </div>
                          <div
                            :style="{
                              color: item.invoice.dProfitPercentage < 0 ? 'red' : 'green',
                            }"
                            style="color: black; font-size: 22px; font-weight: bold"
                          >
                            {{ "$ " + item.invoice.dCurrencyGain + " USD" }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <v-card
                v-if="!isLoadingInvoices"
                class="mb-4"
                v-for="(item, idx) in avaibleInvoices"
                :key="idx"
                style="background-color: #f3f3f369"
              >
                <v-card-title>
                  <div style="display: flex; flex-direction: column; width: 200px">
                    <h3>Invoice: {{ item.sInvoice }}</h3>
                  </div>
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        style="
                          text-align: center;
                          color: #0075B8;
                          font-size: 15px;
                          background-color: transparent;
                          font-family: montserrat-bold;
                          font-weight: 600;
                          line-height: 24px;
                          text-transform: capitalize;
                          word-wrap: break-word;
                          border-radius: 5px;
                          border: 1px solid #0075B8;
                          padding: 8px 16px;
                        "
                        elevation="1"
                        @click="addInvoice(item)"
                        class="ml-2"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        Agregar
                      </v-btn>
                    </template>
                    <span>Agregar factura a la invoice</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text>
                  <div
                    class="mt-8"
                    style="
                      display: flex;
                      justify-content: space-around;
                      flex-direction: column;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        align-items: flex-start;
                        flex-direction: column;
                      "
                    >
                      <div class="my-2">
                        <div style="color: black; font-size: 20px">Monto</div>
                        <div style="color: black; font-size: 22px; font-weight: bold">
                          {{ "$ " + formatMoney(item.dTotalAmount) + "MXN" }}
                        </div>
                      </div>
                      <div class="my-2">
                        <div style="color: black; font-size: 20px">Fecha de compra</div>
                        <div style="color: black; font-size: 22px; font-weight: bold">
                          {{ formatDate(item.dPurchaseDate) }}
                        </div>
                      </div>
                      <div class="my-2">
                        <div style="color: black; font-size: 20px; text-align: center">
                          Exchange rate protected
                        </div>
                        <div style="color: black; font-size: 22px; font-weight: bold">
                          {{ "$ " + formatMoney(item.dRateProtection) + " MXN" }}
                        </div>
                      </div>
                      <div
                        class="my-2"
                        style="display: flex; width: 100%; justify-content: space-around"
                      >
                        <div>
                          <div class="mb-2" style="color: black; font-size: 20px">
                            Profit (%)
                          </div>
                          <div
                            :style="{
                              color: item.dProfitPercentage < 0 ? 'red' : 'green',
                            }"
                            style="color: black; font-size: 22px; font-weight: bold"
                          >
                            {{ formatMoney(item.dProfitPercentage) + "%" }}
                          </div>
                        </div>
                        <div>
                          <div class="mb-2" style="color: black; font-size: 20px">
                            Profit
                          </div>
                          <div
                            :style="{
                              color: item.dCurrencyGain < 0 ? 'red' : 'green',
                            }"
                            style="color: black; font-size: 22px; font-weight: bold"
                          >
                            {{ "$ " + formatMoney(item.dCurrencyGain) + " USD" }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
          <div style="display: flex; justify-content: end; margin-top: 20px">
            <v-btn elevation="0" class="button-cancel mon-regular" @click="cancel()">
              {{ "Cerrar" }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="button-save white--text"
              style="max-width: 200px"
              elevation="0"
              color="#0075B8"
              :disabled="conversion.percent == 0 || loadingTransaction"
              @click="openPayInvoices(conversion)"
              >Pagar facturas
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
      <v-skeleton-loader v-else class="mx-auto" type="image"></v-skeleton-loader>
    </v-dialog>
    <v-dialog v-model="dialogEditInvoice" persistent max-width="600px">
      <v-card>
        <v-card-title style="display: flex; justify-content: flex-start">
          <span class="text-h5">Editar factura</span>
        </v-card-title>
        <v-card-subtitle class="pb-0 mt-3">
          <span style="font-size: 15px"
            >Ingresa la siguiente información para agregar una nueva factura.</span
          >
        </v-card-subtitle>
        <v-card-text v-if="!loading">
          <v-container>
            <v-row>
              <v-form
                ref="formEdit"
                style="width: 100%"
                lazy-validation
                v-on:submit.prevent
              >
                <v-col cols="12">
                  <v-text-field
                    label="Nombre de la invoice*"
                    required
                    outlined
                    hide-details
                    v-model="invoice.sInvoice"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    label="Nombre del proveedor*"
                    required
                    outlined
                    hide-details
                    :items="suppliers"
                    item-value="sPaymentRecipientId"
                    item-text="sName"
                    v-model="invoice.sPaymentRecipientId"
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Fecha de compra*"
                    required
                    outlined
                    hide-details
                    type="date"
                    v-model="invoice.dPurchaseDate"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Total en pesos MXN*"
                    required
                    outlined
                    hide-details
                    type="number"
                    v-model="invoice.dTotalAmount"
                    :rules="[rules.required]"
                  >
                    <template v-slot:append>
                      <div>
                        <h4 class="ml-2 mt-1" >MXN</h4>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Tiempo del credito*"
                    required
                    outlined
                    hide-details
                    type="number"
                    v-model="invoice.iCreditPeriod"
                    :rules="[rules.required]"
                  >
                    <template v-slot:append>
                      <div>
                        <h4 class="ml-2 mt-1" >dias</h4>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Tipo de cambio protegido*"
                    required
                    outlined
                    hide-details
                    type="number"
                    v-model="invoice.dRateProtection"
                    :rules="[rules.required]"
                  >
                    <template v-slot:append>
                      <div>
                        <h4 class="ml-2 mt-1" >MXN</h4>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-form>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <div v-else style="display: flex; justify-content: center">
          <v-progress-circular indeterminate color="amber"></v-progress-circular>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            text
            :disabled="loading"
            @click="dialogEditInvoice = false"
          >
            Cerrar
          </v-btn>
          <v-btn color="#0075B8" class="white--text" :disabled="loading" @click="saveInvoice()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" persistent>
      <v-card class="px-3 py-3">
        <div style="width: 100%; text-align: end;">
          <v-btn icon @click="dialog = false">
            <v-icon color="#2E404E">mdi-close</v-icon>
          </v-btn>
        </div>
         
        <v-card elevation="5" class="mb-6 mx-6 mt-2" style="display: flex; justify-content: space-between;">
          <div class="pa-5" style="display: flex; flex-direction: column;">
            <span class="mon-bold">Cantidad aplicada:</span>
            <span class="mon-bold">{{"$ " + formatMoney(0) + " MXN"}}</span>
          </div>
          <div class="pa-5" style="display: flex; flex-direction: column;">
            <span class="mon-bold">Disponible:</span>
            <span class="mon-bold">{{"$ " + formatMoney(0) + " MXN"}}</span>
          </div>
        </v-card>
        
        <v-card elevation="5" class="mb-6 mx-6">
          <v-card-text>
            <v-row class="pt-4" style="flex-direction: column; overflow-x: auto;">
              <h2 class="pa-4" style="color: black;">Facutras Aplicadas</h2>
              <v-data-table
                item-key="sInvoiceId"
                :headers="headersInvoices"
                disable-sort
                :items="conversion.invoice"
              >
                <template v-slot:item.data-table-select="{ item, select }">
                  <v-checkbox
                    :input-value="isSelected(item)"
                    @click="toggleSelect(item, select)"
                    :disabled="item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                  ></v-checkbox>
                </template>
                <template v-slot:item.dDueDate="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">
                    {{ formatDate(item.invoice.dDueDate) }}
                  </h4>
                </template>
                <template v-slot:item.dPurchaseDate="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">
                    {{ formatDate(item.invoice.dPurchaseDate) }}
                  </h4>
                </template>
                <template v-slot:item.sInvoice="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">{{ item.invoice.sInvoice }}</h4>
                </template>
                <template v-slot:item.sId="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">{{ item.invoice.sId }}</h4>
                </template>
                <template v-slot:item.dTotalAmount="{ item }">
                  <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                    $ {{ formatMoney(item.dAmount) }} MXN
                  </h4>
                </template>
                <template v-slot:item.dRateProtection="{ item }">
                  <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                    $ {{ formatMoney(item.invoice.dRateProtection) }} MXN
                  </h4>
                </template>
                <template v-slot:item.dProfitPercentage="{ item }">
                  <h4
                    :style="{ color: item.dProfitPercentage < 0 ? 'red' : 'green' }"
                    style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                  >
                    {{ formatMoney(item.invoice.dProfitPercentage) + "%" }}
                  </h4>
                </template>
                <template v-slot:item.dCurrencyGain="{ item }">
                  <h4
                    :style="{ color: item.invoice.dCurrencyGain < 0 ? 'red' : 'green' }"
                    style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                  >
                    $ {{ formatMoney(item.invoice.dCurrencyGain) }} USD
                  </h4>
                </template>
                <template v-slot:item.sStatusId="{ item }">
                  <v-chip
                    v-if="item.invoice.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                    class="ma-2"
                    color="primary"
                    outlined
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.invoice.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'"
                    class="ma-2"
                    outlined
                    color="green"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Assigned" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.invoice.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'"
                    class="ma-2"
                    outlined
                    color="#193D6E"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.invoice.sStatusId == '63b83525-e0ff-4d52-821a-df20611cb4a3'"
                    class="ma-2"
                    outlined
                    color="red"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Parcial" }}</h4>
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div style="display: flex; align-items: center; justify-content: center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="editInvoice(item)"
                          :disabled="
                            loading ||
                            item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                          "
                          v-bind="attrs"
                          v-on="on"
                          icon
                          color="black"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar factura</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="openDialogDeleteInvoice(item)"
                          :disabled="
                            loading ||
                            item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                          "
                          v-bind="attrs"
                          v-on="on"
                          icon
                          color="red"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete item</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
              <!-- <v-card v-else class="py-8" style="width: 100%; text-align: center;">
                <v-card-text>
                  <h4>No hay facturas disponibles</h4>
                </v-card-text>
              </v-card> -->
            </v-row>
          </v-card-text>
        </v-card>
        <v-card elevation="5" class="mb-6 mx-6">
          <v-card-text>
            <v-row class="pt-4" style="flex-direction: column; overflow-x: auto;">
              <h2 class="pa-4" style="color: black;">Facutras Disponibles</h2>
              <!-- <div v-if="avaibleInvoices">
                <div v-if="avaibleInvoices.length > 0">
                  <v-data-table
                    item-key="sInvoiceId"
                    :headers="headersInvoices"
                    disable-sort
                    :items="avaibleInvoices"
                  >
                    <template v-slot:item.sName="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">{{ item.sName }}</h4>
                    </template>
                    <template v-slot:item.dDueDate="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">
                        {{ formatDate(item.dDueDate) }}
                      </h4>
                    </template>
                    <template v-slot:item.dPurchaseDate="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">
                        {{ formatDate(item.dPurchaseDate) }}
                      </h4>
                    </template>
                    <template v-slot:item.sInvoice="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">{{ item.sInvoice }}</h4>
                    </template>
                    <template v-slot:item.sId="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">{{ item.sId }}</h4>
                    </template>
                    <template v-slot:item.dTotalAmount="{ item }">
                      <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                        $ {{ formatMoney(item.dTotalAmount) }} MXN
                      </h4>
                    </template>
                    <template v-slot:item.dRateProtection="{ item }">
                      <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                        $ {{ formatMoney(item.dRateProtection) }} MXN
                      </h4>
                    </template>
                    <template v-slot:item.dProfitPercentage="{ item }">
                      <h4
                        :style="{ color: item.dProfitPercentage < 0 ? 'red' : 'green' }"
                        style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                      >
                        {{ formatMoney(item.dProfitPercentage) + "%" }}
                      </h4>
                    </template>
                    <template v-slot:item.dCurrencyGain="{ item }">
                      <h4
                        :style="{ color: item.dCurrencyGain < 0 ? 'red' : 'green' }"
                        style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                      >
                        $ {{ formatMoney(item.dCurrencyGain) }} USD
                      </h4>
                    </template>
                    <template v-slot:item.sStatusId="{ item }">
                      <v-chip
                        v-if="item.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                        class="ma-2"
                        color="primary"
                        outlined
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                      </v-chip>
                      <v-chip
                        v-else-if="item.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'"
                        class="ma-2"
                        outlined
                        color="green"
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "Assigned" }}</h4>
                      </v-chip>
                      <v-chip
                        v-else-if="item.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'"
                        class="ma-2"
                        outlined
                        color="#193D6E"
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                      </v-chip>
                      <v-chip
                        v-else-if="item.sStatusId == '63b83525-e0ff-4d52-821a-df20611cb4a3'"
                        class="ma-2"
                        outlined
                        color="red"
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "Parcial" }}</h4>
                      </v-chip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div style="display: flex; align-items: center; justify-content: center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="editInvoice(item)"
                              :disabled="
                                loading ||
                                item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                              "
                              v-bind="attrs"
                              v-on="on"
                              icon
                              color="black"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Editar factura</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="openDialogDeleteInvoice(item)"
                              :disabled="
                                loading ||
                                item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                              "
                              v-bind="attrs"
                              v-on="on"
                              icon
                              color="red"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete item</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </div>
                <v-card v-else class="py-8" style="width: 100%; text-align: center;">
                  <v-card-text>
                    <h4>No hay facturas disponibles</h4>
                  </v-card-text>
                </v-card>
              </div> -->
              <v-data-table
                item-key="sInvoiceId"
                :headers="headersInvoices"
                disable-sort
                :items="avaibleInvoices"
              >
                <template v-slot:item.data-table-select="{ item, select }">
                  <v-checkbox
                    :input-value="isSelected(item)"
                    @click="toggleSelect(item, select)"
                    :disabled="item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                  ></v-checkbox>
                </template>
                <template v-slot:item.dDueDate="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">
                    {{ formatDate(item.dDueDate) }}
                  </h4>
                </template>
                <template v-slot:item.dPurchaseDate="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">
                    {{ formatDate(item.dPurchaseDate) }}
                  </h4>
                </template>
                <template v-slot:item.sInvoice="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">{{ item.sInvoice }}</h4>
                </template>
                <template v-slot:item.sId="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">{{ item.sId }}</h4>
                </template>
                <template v-slot:item.dTotalAmount="{ item }">
                  <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                    $ {{ formatMoney(item.dTotalAmount) }} MXN
                  </h4>
                </template>
                <template v-slot:item.dRateProtection="{ item }">
                  <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                    $ {{ formatMoney(item.dRateProtection) }} MXN
                  </h4>
                </template>
                <template v-slot:item.dProfitPercentage="{ item }">
                  <h4
                    :style="{ color: item.dProfitPercentage < 0 ? 'red' : 'green' }"
                    style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                  >
                    {{ formatMoney(item.dProfitPercentage) + "%" }}
                  </h4>
                </template>
                <template v-slot:item.dCurrencyGain="{ item }">
                  <h4
                    :style="{ color: item.dCurrencyGain < 0 ? 'red' : 'green' }"
                    style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                  >
                    $ {{ formatMoney(item.dCurrencyGain) }} USD
                  </h4>
                </template>
                <template v-slot:item.sStatusId="{ item }">
                  <v-chip
                    v-if="item.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                    class="ma-2"
                    color="primary"
                    outlined
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'"
                    class="ma-2"
                    outlined
                    color="green"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Assigned" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'"
                    class="ma-2"
                    outlined
                    color="#193D6E"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.sStatusId == '63b83525-e0ff-4d52-821a-df20611cb4a3'"
                    class="ma-2"
                    outlined
                    color="red"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Parcial" }}</h4>
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div style="display: flex; align-items: center; justify-content: center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="editInvoice(item)"
                          :disabled="
                            loading ||
                            item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                          "
                          v-bind="attrs"
                          v-on="on"
                          icon
                          color="black"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar factura</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="openDialogDeleteInvoice(item)"
                          :disabled="
                            loading ||
                            item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                          "
                          v-bind="attrs"
                          v-on="on"
                          icon
                          color="red"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete item</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export default {
  name: "DashboardView",
  data() {
    return {
      nameXLSX: "ConversionesDisponibles.xlsx",
      texts: "",
      drawer: null,
      dialogEditInvoice: false,
      dialogSendPayOfInvoice: false,
      dialogDetailConversion: false,
      actualCurrency: "0",
      actualCurrencyMxn: "0",
      referenceCurrency: "0",
      isLoading: false,
      isRegisterEfex: true,
      headersInvoices: [
        this.selectLanguage === 'en' ? { text: "Invoice", value: "sInvoice", align: "center" } : { text: "Factura", value: "sInvoice", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase Order", value: "sId", align: "center" } : { text: "Orden de compra", value: "sId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase date", value: "dPurchaseDate", align: "center" } : { text: "Fecha de compra", value: "dPurchaseDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Due date", value: "dDueDate", align: "center" } : { text: "Fecha de vencimiento", value: "dDueDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Status", value: "sStatusId", align: "center" } : { text: "Estado", value: "sStatusId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Total amount MXN", value: "dTotalAmount", align: "center" } : { text: "Monto total MXN", value: "dTotalAmount", align: "center" },
        this.selectLanguage === 'en' ? { text: "Exchange rate protection MXN", value: "dRateProtection", align: "center", sortable: false } : { text: "Cobertura de tasa de cambio MXN", value: "dRateProtection", align: "center", sortable: false },   
        this.selectLanguage === 'en' ? { text: "Currency profit (%)", value: "dProfitPercentage", align: "center" } : { text: "Beneficio de moneda (%)", value: "dProfitPercentage", align: "center" },
        this.selectLanguage === 'en' ? { text: "Currency gain", value: "dCurrencyGain", align: "center" } : { text: "Beneficio de moneda", value: "dCurrencyGain", align: "center" },
        this.selectLanguage === 'en' ? { text: "Actions", value: "actions", align: "center" } : { text: "Acciones", value: "actions", align: "center" }
      ],
      exchangeRateData: [],
      selected: [],
      selectedSupplier: null,
      exchangeRateDataPaid: [],
      exchangeRateDataSeparate: [],
      balanceMxn: "0",
      balanceUsd: "0",
      balance: "0",
      items: [],
      active: false,
      comment: null,
      tab: 0,
      contacts: [],
      step: 0,
      itemsSelected: [],
      totalProfit: "",
      itemsSelectedForwards: [],
      isForwardRateCalculated: false,
      bSelectedAll: false,
      dialogAddFoundss: false,
      dialogSendPay: false,
      dialogAddFounds: false,
      dataAddFounds: {},
      dialogCreate: false,
      dialogPay: false,
      editableData: {},
      selectedCard: null,
      today: null,
      otp: "",
      totalUsd: 0,
      selectedMenuItem: "dashboard",
      contactData: {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY",
      },
      isForwardsActive: false,
      suppliers: [],
      isLoadingInvoices: false,
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      bLoading: false,
      isDeferredPayment: false,
      stepper: false,
      dialog: false,
      e1: 1,
      timerCount: 30,
      rules: {
        required: (v) => !!v || "El campo es obligatorio",
      },
      headersForex: [
        { text: "Id", value: "iTrackingId", align: "center", sortable: false, },
        { text: "Fecha de creación", value: "created_at", align: "center" },
        { text: "Type Transaction", value: "sTransactionType", align: "center", },
        { text: "Total amount USD", value: "dAmount", align: "center" },
        { text: "Total amount MXN", value: "dDesAmount", align: "center" },
        { text: "Exchange rate", value: "dExchangeRate", align: "center" },
        { text: "% Asignado", value: "dPercentAssigned", align: "center", sortable: false, },
        { text: "Invoice", value: "invoices", align: "center", sortable: false },
        { text: "Purchase date", value: "purchaseDate", align: "center", sortable: false, },
        { text: "Currency profit (%)", value: "percentProfit", align: "center", sortable: false, },
        { text: "Currency gain", value: "dollarProfit", align: "center", sortable: false, },
        { text: "Actions", value: "actions", align: "center", sortable: false },
      ],
      timerId: null,
      dataEfex: {},
      avaibleInvoices: [],
      loading: false,
      exchangeRateAdjustments: [],
      exchangeRatesStateForwards: [],
      isPayMxn: false,
      loadingTransaction: false,
      bSelectedAllSeparate: false,
      dialogEditProfileActive: false,
      isForwards: false,
      isForwardsPayment: false,
      userName: "",
      modalCurrency: 0,
      sections: [
        {
          icon: "mdi mdi-view-dashboard",
          value: "operation",
          title: "Operaciones",
          items: [
            {
              icon: "mdi mdi-view-dashboard",
              value: "dashboard",
              title: "Dashboard",
              disabled: false,
            },
            {
              icon: "mdi-file-document",
              value: "history",
              title: "Seguimiento de facturas",
              disabled: false,
            },
            {
              icon: "mdi-forward",
              value: "activeForwards",
              title: "Forwards activos",
              disabled: false,
            },
          ],
        },
        {
          icon: "mdi-history",
          value: "history",
          title: "Historial",
          items: [
            {
              icon: "mdi-file-document",
              value: "exchangeRate",
              title: "Historial de conversiones",
              disabled: true,
            },
            {
              icon: "mdi-file-document",
              value: "history",
              title: "Historial de pagos",
              disabled: false,
            },
          ],
        },
        {
          icon: "mdi-wallet",
          value: "wallets",
          title: "Wallets",
          items: [
            {
              icon: "mdi-account-group",
              value: "suppliers",
              title: "Proveedores",
              disabled: true,
            },
            {
              icon: "mdi-account-group",
              value: "suppliers",
              title: "Estado de cuenta",
              disabled: true,
            },
          ],
        },
      ],
      miniVariant: true,
      expandOnHover: false,
      registerFields: [
        { model: "sBankName", type: "text", label: "sBankName" },
        { model: "sAccountNumber", type: "text", label: "sAccountNumber" },
        { model: "sRoutingNumber", type: "text", label: "sRoutingNumber" },
      ],
      transactions: [],
      conversion: {},
      invoices: [],
      invoice: {},
      supplier: {},
      sAccountNumber: null,
      sPaymentRecipientId: "",
      conversionPayment: {
        sTransactionId: "",
        sPaymentRecipientId: "",
        dAmount: "",
        detail: {
          supplier: {},
          conversion: {},
        },
      },
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    tabStyle(tabIndex) {
      return {
        color: this.tab === tabIndex ? "#f0be43" : "#506172",
        fontSize: "16px",
        fontWeight: "600",
        width: "200px",
        lineHeight: "24px",
        fontFamily: "montserrat-bold",
      };
    },
    handleResize: function () {
      if (window.innerWidth >= 960) {
        this.screenWidth = 30;
      } else {
        this.screenWidth = 100;
      }

      this.isResponsive = window.innerWidth < 960;
    },
    updateInvoice() {
      this.active = true;
      this.dialog = true;
      if (this.sPaymentRecipientId) {
        this.getInvoicesWithSupplier(this.sPaymentRecipientId);
      }
    },
    saveInvoice() {
      if (this.$refs.formEdit.validate()) {
        this.loading = true;

        let payload = {
          sInvoiceId: this.invoice.sInvoiceId,
          dPurchaseDate: this.invoice.dPurchaseDate,
          sPaymentRecipientId: this.invoice.sPaymentRecipientId,
          sInvoice: this.invoice.sInvoice,
          dTotalAmount: this.invoice.dTotalAmount,
          dRateProtection: this.invoice.dRateProtection,
          iCreditPeriod: this.invoice.iCreditPeriod,
          sTransactionId: this.conversion.sTransactionId,
          exchangeRate: this.conversion.dExchangeRate,
        };

        DB.put(`${URI}/api/v1/${this.selectLanguage}/invoices/conversion`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            this.loading = false;
            this.loadingTransaction = false;
            this.getConversionsWithId(this.conversion);
            this.active = false;
            this.dialogEditInvoice = false;
          })
          .catch((error) => {
            this.loading = false;
            this.mixError(error.response.data.message, error.response.status);
          });
      } else {
        this.error = true;
        this.codeError = "INVALID_INPUT";
      }
    },
    goToInvoice(item) {
      this.$router.push(`/invoices/${item.sInvoiceId}`);
    },
    openInvoice(item) {
      this.loading = true;
      const payload = {
        sInvoiceId: item.sInvoiceId,
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/invoices/id`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.loading = false;
          this.invoice = response.data.invoice;
          this.invoice.dPurchaseDate = moment(response.data.invoice.dPurchaseDate).format(
            "YYYY-MM-DD"
          );
          this.dialogEditInvoice = true;
        })
        .catch((error) => {
          this.loading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    openDialog(item) {
      this.$router.push("/balance/" + item.sTransactionId);
      // this.dialogDetailConversion = true;
      // this.getConversionsWithId(item);
    },
    cancelDialog() {
      this.dialogSendPayOfInvoice = false;
      this.comment = null;
    },
    addInvoice(item) {
      this.loadingTransaction = true;
      this.avaibleInvoices = [];

      const payload = {
        sTransactionId: this.conversion.sTransactionId,
        invoices: [
          {
            sInvoiceId: item.sInvoiceId,
            dAmount: item.dTotalAmount,
          },
        ],
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/transactions/invoice`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.loadingTransaction = false;
          this.getConversionsWithId(this.conversion);
          this.active = false;
        })
        .catch((error) => {
          this.loadingTransaction = false;
          this.mixError(error.response.data.message, error.response.status);
          this.getInvoicesWithSupplier(this.sPaymentRecipientId);
        });
    },
    deleteInvoice(item) {
      this.loadingTransaction = true;

      const payload = {
        sTransactionId: this.conversion.sTransactionId,
        invoices: [
          {
            sInvoiceId: item.sInvoiceId,
            dAmount: item.dTotalAmount,
          },
        ],
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/transactions/deleteInvoice`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      )
        .then((response) => {
          this.loadingTransaction = false;
          this.getConversionsWithId(this.conversion);

          this.active = false;
        })
        .catch((error) => {
          this.loadingTransaction = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    selectSupplier(item) {
      this.conversionPayment.detail.supplier = item;
      this.conversionPayment.detail.sPaymentRecipientId = item.sPaymentRecipientId;
      this.sAccountNumber = this.conversionPayment.detail.supplier.sAccountNumber.slice(
        -4
      );
    },
    sendVerification(step) {
      this.step = step;
      try {
        DB.get(`${URI}/api/v1/${this.selectLanguage}/authenticator/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }).then((response) => {
          if(!response.data.success){
            this.mixError(response.data.message, response.status);
          }
        })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
        }
        catch(error){
          this.mixError(error.response.data.message, error.response.status);
        }
    },
    openPayNow(item) {
      this.conversionPayment.detail.sTransactionId = item[0].sTransactionId;
      this.conversionPayment.detail.dAmount = item[0].dDesAmount;
      this.conversionPayment.detail.conversion = item;
      if (item[0].invoice.length == 0) {
        this.dialogSendPay = true;
        this.step = 1;
      } else {
        this.dialogSendPay = true;
        this.conversionPayment.detail.supplier = this.suppliers.find(
          (supplier) =>
            supplier.sPaymentRecipientId ===
            item[0].invoice[0].invoice.sPaymentRecipientId
        );
        this.conversionPayment.detail.sPaymentRecipientId =
          item[0].invoice[0].invoice.sPaymentRecipientId;
        this.sAccountNumber = this.conversionPayment.detail.supplier.sAccountNumber.slice(
          -4
        );
        this.step = 2;
      }
    },
    openPayInvoices(item) {
      this.dialogSendPayOfInvoice = true;
      this.conversionPayment.detail.sTransactionId = item.sTransactionId;
      this.conversionPayment.detail.dAmount = item.totalAmount;
      this.conversionPayment.detail.conversion = [item];
      this.conversionPayment.detail.supplier = this.suppliers.find(
        (supplier) =>
          supplier.sPaymentRecipientId === item.invoice[0].invoice.sPaymentRecipientId
      );
      this.conversionPayment.detail.sPaymentRecipientId =
        item.invoice[0].invoice.sPaymentRecipientId;
      this.sAccountNumber = this.conversionPayment.detail.supplier.sAccountNumber.slice(
        -4
      );
      this.step = 1;
    },
    sendPayment() {
      this.loading = true;
      const payload = {
        sTransactionId: this.conversionPayment.detail.sTransactionId,
        sPaymentRecipientId: this.conversionPayment.detail.sPaymentRecipientId,
        isMxn: true,
        dAmount: this.conversionPayment.detail.dAmount,
        comment: this.comment,
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/payments/`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.cancel();
          this.loadingTransaction = false;
          this.getPaymentsHistory();
          this.getSuppliers();
        })
        .catch((error) => {
          this.loading = false;
          this.loadingTransaction = false;
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getInvoicesWithSupplier(item) {
      this.isLoadingInvoices = true;
      this.avaibleInvoices = [];

      const payload = {
        sPaymentRecipientId: item,
        dExchangeRate: this.conversion.dExchangeRate,
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/invoices/supplier`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.avaibleInvoices = response.data.invoices;
          this.isLoadingInvoices = false;
        })
        .catch((error) => {
          this.isLoadingInvoices = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    cancel() {
      this.dialogEditInvoice = false;
      this.dialogSendPay = false;
      this.comment = null;
      this.loadingTransaction = false;
      this.dialogSendPayOfInvoice = false;
      this.step = 0;
      this.avaibleInvoices = [];
      this.selected = [];
      this.dialogDetailConversion = false;
      this.active = false;
      this.selectedSupplier = [];
    },
    getPaymentsHistory() {
      this.loadingTransaction = true;
      this.conversion = [];

      DB.get(`${URI}/api/v1/${this.selectLanguage}/transactions/detail/${this.$route.params.idConversion}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
        })
        .then((response) => {
          this.conversionWithId = response.data.transactions.map((transaction) => {
            let totalAmount = 0;
            if (transaction.invoice.length > 0) {
              transaction.invoice.map((invoice) => {
                totalAmount += parseFloat(invoice.invoice.dTotalAmount);
              });
            }
            transaction.totalAmount = totalAmount;
            transaction.percent =
              (transaction.totalAmount / transaction.dDesAmount) * 100;
            return transaction;
          });

          this.conversion = this.conversionWithId[0];

          if (this.conversion.invoice.length > 0) {
            this.sPaymentRecipientId = this.conversion.invoice[0].invoice.paymentsRecipent[0].sPaymentRecipientId;
          } else {
            this.sPaymentRecipientId = null;
          }

          this.getConversions();
          this.loadingTransaction = false;
        })
      .catch((error) => {
        this.loadingTransaction = false;
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    getConversions() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/transactions/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.totalProfit = response.data.totalProfit;
          this.items = response.data.transactions.map((transaction) => {
            let totalAmount = 0;
            let invoices = []
            let purchaseDate = []
            if (transaction.invoice.length > 0) {
              transaction.invoice.map((invoice) => {
                totalAmount += parseFloat(invoice.dAmount);
                invoices.push(invoice.invoice.sInvoice)
                purchaseDate.push(this.formatDate(invoice.invoice.dPurchaseDate))
              });
            }
            transaction.invoices = invoices.join(', ');
            transaction.purchaseDate = purchaseDate.join(', ');

            transaction.percent = (totalAmount / transaction.dDesAmount) * 100;
            transaction.totalAmount = totalAmount;
            return transaction;
          });

          this.items.sort((a, b) => {
            const dateA = new Date(a.created_at);
            const dateB = new Date(b.created_at);

            return dateB - dateA;
          });
          this.isLoading = false;
          this.balanceMxn = response.data.balance.balanceMxn.balance;
        })
        .catch((error) => {
          // this.isLoading = false;
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    getInvoices() {
      DB.get(
        `${URI}/api/v1/${this.selectLanguage}/invoices/?exchangeRateToday=${this.actualCurrency}`,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      ).then((response) => {
        this.invoices = response.data.invoices;
      });
    },
    getTransactions() {
      DB.get(`${URI}/api/v1/${this.selectLanguage}/transactions/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      }).then((response) => {
        this.transactions = response.data.transactions;
      });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    getExchangeRate: function () {
      this.items = [];

      DB.get(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/?exchangeRateToday=${this.actualCurrency}`,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      )
        .then((response) => {
          this.isForwardsActive = response.data.isForwardsActive;
          this.userName = response.data.user;
          this.isRegisterEfex = response.data.registerInEfex;
          this.exchangeRateDataPaid = response.data.exchangeRate.exchangeRatesStatePaid;
          this.exchangeRateData = response.data.exchangeRate.exchangeRatesStateToPay;
          this.exchangeRateDataSeparate =
            response.data.exchangeRate.exchangeRatesStateSeparated;
          this.exchangeRatesStateForwards =
            response.data.exchangeRate.exchangeRatesStateForwards;
          this.balanceMxn = response.data.balance.balanceMxn;
          this.balanceUsd = response.data.balance.balanceUsd;
          this.exchangeRateAdjustments = response.data.exchangeRateAdjustments;
          this.balance =
            parseFloat(this.balanceMxn) / parseFloat(this.actualCurrency) +
            parseFloat(this.balanceUsd);
          this.balance = this.balance.toString();

          // this.totalUsd = 0;

          // this.itemsSelected.forEach((item) => {
          //   item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
          //   this.totalUsd += item.dTotalUsdToday;
          // });

          this.mixSuccess(response.data.message);
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.getContacts();
        });
    },
    getContacts: function () {
      DB.get(`${URI}/api/v1/${this.selectLanguage}/contacts-wallet/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.contacts = response.data.contacts;
          this.contacts.push({
            id: 0,
            name: "Crear nuevo contacto",
          });
        })
        .catch((error) => {
          // Handle error if needed
        });
    },
    openModalAddFoundss() {
      this.dialogAddFoundss = true;

      const payload = {
        amount: 100,
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/exchange-rate/addFounds`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.dataAddFounds = response.data.account;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    closeModalAddFounds() {
      this.dialogAddFounds = false;
    },
    toggleAll: function (checked) {
      this.exchangeRateData.forEach((item) => {
        if (
          item.statusName !== "WAITING_FOR_DEPOSIT" ||
          item.statusName !== "PROCESSING"
        ) {
          item.bSelected = checked;
        }
      });
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    // formatMoney: function (money) {
    //   return FORMAT_MONEY(money);
    // },
    resetForm() {
      this.editableData = {
        dPurchaseDate: "",
        sProvider: "",
        sInvoiceNumber: "",
        dDesAmount: "",
        iCreditPeriod: "",
        dInvoiceExchangeRateProtection: "",
      };
    },
    openModalCreate() {
      this.dialogCreate = true;
      this.resetForm();
    },
    validateForm: function () {
      return true;
    },
    saveChanges: function () {
      this.bLoading = true;
      let newdPurchaseDate = this.formatDateToSend(this.editableData.dPurchaseDate);

      const payload = {
        dPurchaseDate: newdPurchaseDate.toString(),
        sProvider: this.editableData.sProvider,
        sInvoiceNumber: this.editableData.sInvoiceNumber,
        dDesAmount: parseFloat(this.editableData.dDesAmount),
        iCreditPeriod: parseInt(this.editableData.iCreditPeriod),
        createContact: this.showCreateProvider,
        contactData: this.contactData,
        dInvoiceExchangeRateProtection: this.editableData.dInvoiceExchangeRateProtection,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/exchange-rate/`, payload, config)
        .then((response) => {
          this.bLoading = false;
          this.dialogCreate = false;
          this.mixSuccess(response.data.message);
          this.getExchangeRate();
          this.closeDialog();
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatDateToSend: function (date) {
      let newDate = new Date(date);
      let day = newDate.getDate() + 1;
      let month = newDate.getMonth() + 1;
      let year = newDate.getFullYear();
      return `${year}-${month}-${day}`;
    },
    changebSelectedAll: function () {
      this.bSelectedAll = !this.bSelectedAll;
    },
    closeModalCreate() {
      this.dialogCreate = false;
      this.showCreateProvider = false;
      this.contactData = {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY",
      };
    },
    sendToPayNow: function () {
      this.isDeferredPayment = false;
      this.sendToPay();
    },
    sendToPay: function () {
      this.itemsSelected = this.exchangeRateData.filter((item) => item.bSelected);
      if (this.itemsSelected.length > 0) {
        this.stepper = true;
        this.itemsSelected.forEach((item) => {
          item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
          this.totalUsd += item.dTotalUsdToday;
        });
      } else {
        this.mixError("No hay elementos seleccionados", 400);
      }
    },
    actualizarE1(nuevoValor) {
      this.e1 = nuevoValor;
    },
    closeModalPay() {
      this.dialogPay = false;
      this.totalUsd = 0;
      this.e1 = 1;
    },
    sendToPayNowMxn: function () {
      this.isDeferredPayment = false;
      this.isPayMxn = true;
      this.itemsSelected = this.exchangeRateDataSeparate.filter((item) => item.bSelected);
      this.itemsSelected.forEach((item) => {
        item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
        this.totalUsd += item.dTotalUsdToday;
      });

      if (this.itemsSelected.length > 0) {
        this.dialogPay = true;
      } else {
        this.mixError("No hay elementos seleccionados", 400);
      }
    },
    sendToPayNowForwards: function () {
      this.isPayMxn = true;
      this.itemsSelected = this.exchangeRatesStateForwards.filter(
        (item) => item.bSelected
      );
      this.itemsSelected.forEach((item) => {
        item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
        this.totalUsd += item.dTotalUsdToday;
      });

      if (this.itemsSelected.length > 0) {
        this.sendPayEfex();
      } else {
        this.mixError("No hay elementos seleccionados", 400);
      }
    },
    closeModalStepper() {
      this.stepper = false;
      this.totalUsd = 0;
      this.e1 = 1;
      this.isForwards = false;
      this.isForwardsPayment = false;
      //this.getActualCurrency();
    },
    changeDeferredPayment() {
      this.isDeferredPayment = !this.isDeferredPayment;
    },
    changePayMxn() {
      this.isPayMxn = !this.isPayMxn;
    },
    sendPayEfex: function () {
      this.bLoading = true;

      if (this.isPayMxn) {
        this.totalUsd = this.totalUsd * this.actualCurrency;
      }

      const payload = {
        pays: this.itemsSelected,
        referenceCurrency: this.referenceCurrency,
        actualCurrency: this.actualCurrency,
        isDeferredPayment: this.isDeferredPayment,
        isPayMxn: this.isPayMxn,
        totalUsd: this.totalUsd,
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/sendPayment/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message, 400);
          } else {
            this.mixSuccess(response.data.message);
          }
          this.bLoading = false;
          this.dialogPay = false;
          this.defferedPayment = false;
          this.getExchangeRate();
          this.totalUsd = 0;
          this.isPayMxn = false;
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.data.message, error.response.status);
        });
    },
    openReceipt: function (item) {
      DB.get(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/getPaymentRecipt/${item.paymentExchangeRate[0].sPayment_reference}/`,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      )
        .then((response) => {
          if (response.data && response.data.payment) {
            let base64 = response.data.payment.data;

            const base64Pattern = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
            if (base64Pattern.test(base64)) {
              base64 = base64.split(",")[1];
            }

            try {
              const binaryString = window.atob(base64);
              const bytes = new Uint8Array(binaryString.length);
              for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
              }
              const blob = new Blob([bytes], { type: "application/pdf" });

              const url = URL.createObjectURL(blob);
              window.open(url, "_blank");
            } catch (e) {
              console.error("Error al decodificar base64: ", e);
            }
          } else {
            console.error("No se encontraron los datos del PDF en la respuesta");
          }
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    sendSeparateEfex: function () {
      this.bLoading = true;
      const payload = {
        exchangeRateId: this.itemsSelected,
        rateUuid: this.referenceCurrency,
        rateInt: this.actualCurrency,
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/separateExchangeRate/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message);
          } else {
            this.mixSuccess(response.data.message);
          }
          this.bLoading = false;
          this.dialogSeparate = false;
          this.getExchangeRate();
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    toggleAllSeparated: function (checked) {
      this.exchangeRateDataSeparate.forEach((item) => {
        item.bSelected = checked;
      });
    },
    toggleAllForwards: function (checked) {
      this.exchangeRatesStateForwards.forEach((item) => {
        this.$set(item, "bSelected", checked);
      });
    },
    createSubAccount(data) {
      const payload = {
        sBank_name: data.sBankName,
        sAccount_number: data.sAccountNumber,
        sRouting_number: data.sRoutingNumber,
        clabe: data.clabe,
        sBank_mxn_account: data.sBankMxnAccount,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/sub-account/`, payload, config)
        .then((response) => {
          this.mixSuccess(response.data.message);
          this.getExchangeRate();
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    openModal(item) {
      this.totalUsd = 0;
      this.selectedItem = item;
      this.editableData = { ...this.selectedItem };
      this.dialogEditProfileActive = true;
    },
    closeDialog() {
      this.dialogEditProfileActive = false;
    },
    backStep() {
      this.e1 = 1;
    },
    updateExchangeRate: function () {
      this.bLoading = true;
      let newdPurchaseDate = this.formatDateToSend(this.editableData.dPurchaseDate);
      const payload = {
        sExchangeRateId: this.selectedItem.sExchangeRateId,
        dPurchaseDate: newdPurchaseDate.toString(),
        sProvider: this.editableData.sProvider,
        sInvoiceNumber: this.editableData.sInvoiceNumber,
        dDesAmount: parseFloat(this.editableData.dDesAmount),
        iCreditPeriod: parseInt(this.editableData.iCreditPeriod),
        dInvoiceExchangeRateProtection: this.editableData.dInvoiceExchangeRateProtection,
        dAmountAdjustment: parseFloat(this.editableData.dAmountAdjustment),
        sCurrencyAdjustment: "MXN",
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.put(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/${this.selectedItem.sExchangeRateId}`,
        payload,
        config
      )
        .then((response) => {
          this.bLoading = false;
          this.dialogEditProfileActive = false;
          this.mixSuccess(response.data.message);
          this.getExchangeRate();
          this.closeDialog();
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    changeForwards: function (value) {
      this.isForwards = value;
    },
    getForwards: function () {
      this.bLoading = true;
      const payload = {
        pays: this.itemsSelected,
        referenceCurrency: this.referenceCurrency,
        reverse: true,
      };
      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/getRateForwards/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message, 400);
            this.bLoading = false;
            this.isForwardsPayment = false;
          } else {
            this.mixSuccess(response.data.message);
            this.bLoading = false;
            this.isForwardsPayment = true;
            this.isForwardRateCalculated = response.data.isForwardRateCalculated;
            this.itemsSelected = response.data.responsePaysEfex;
          }
          this.getExchangeRate();
        })
        .catch((error) => {
          this.bLoading = false;
          this.isForwardsPayment = false;
          this.mixError(error.data.message, 400);
        });
    },
    sendForwardPayment: function () {
      const payload = {
        pays: this.itemsSelected,
      };
      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/sendPayForward/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message, 400);
          } else {
            this.mixSuccess(response.data.message);
          }
          this.bLoading = false;
          this.stepper = false;
          this.defferedPayment = false;
          this.getExchangeRate();
          this.totalUsd = 0;
          this.isForwardsPayment = false;
          this.isPayMxn = false;
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    changeModalCurrency: function (value) {
      this.modalCurrency = value;
    },
    updateTotalUsd: function (value) {
      this.totalUsd = value;
    },
    getSuppliers() {
      this.isLoadingSuppliers = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/payment-recipient/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      }).then((response) => {
        this.isLoadingSuppliers = false;
        this.suppliers = response.data.paymentRecipients;
      });
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Id: item.iTrackingId ? item.iTrackingId : "",
            "Fecha de creación": item.created_at ? this.formatDate(item.created_at) : "",
            "Type Transaction": item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3' ? 'Forward' : (item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a' ? 'Forex' : "N/A"),
            "Total amount (USD)": item.dAmount ? parseFloat(item.dAmount) : "",
            "Total amount (MXN)": item.dDesAmount ? parseFloat(item.dDesAmount) : "",
            "Exchange rate": item.dExchangeRate ? item.dExchangeRate : "",
            Invoice: item.invoice ? item.invoice : "",
            "Purchase Date": item.purchaseDate ? item.purchaseDate : "",
            "Currency profit (%)": item.percentProfit ? parseFloat(item.percentProfit) : "",
            "Currency gain (USD)": item.dollarProfit ? parseFloat(item.dollarProfit) : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getPaymentsHistory();
    this.getSuppliers();
    this.today = moment().format("YYYY-MM-DD");
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    formattedTime() {
      const minutes = Math.floor(this.timerCount / 60);
      const seconds = this.timerCount % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
    },
    "editableData.sProvider": function (newValue) {
      this.showCreateProvider = newValue === 0;
    },
  },
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #fff;
  opacity: 1;
  height: 100%;
}
.full-height {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
}
.active {
  background-color: #f0f0f0;
}
/* .active-section .v-list-item__icon {
  color: yellow !important;
  background-color: yellow !important;
}

.active-section .v-list-item__title {
  background-color: yellow !important;
} */

.active-item {
  background-color: #f5f7f9 !important;
}
.button-add {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}
.v-tabs-slider {
  background: #f0be43 !important;
  height: 3px;
  color: #f0be43 !important;
  border-radius: 100px;
}

.card-main {
  width: fit-content;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

.card-content {
  position: absolute;
  top: 19px;
  left: 16px;
}

.circle-content {
  text-align: center;
  color: white;
  margin: auto;
}

.btn-custom {
  color: #f0be43;
}

.card-title {
  color: #302e2e;
  font-size: 16px;
  font-family: montserrat-bold;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.card-info,
.balance-title {
  color: #777777;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.card-mxn {
  width: 200px;
  color: #f0be43;
  font-size: 24px;
  font-family: Mons;
  font-weight: 700;
  line-height: 36px;
  font-style: normal;
  word-wrap: break-word;
}

.container-width,
.header-container {
  max-width: 1280px;
  margin: auto;
}

.title-medium {
  font-family: "montserrat-semibold";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.headline-medium {
  font-family: "montserrat-semibold";
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.body-large {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.blocked-amount {
  font-family: "montserrat-regular";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.blocked-amount-2 {
  color: #302e2e;
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.circle-sheet {
  width: 200px;
  height: 200px;
  padding-left: 17px;
  padding-right: 62px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  position: absolute;
  right: -60px;
  top: -20px;
}

.usd-balance {
  color: #666565;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.content-balance {
  color: #302e2e;
  font-family: "montserrat-medium", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  padding-top: 10px;
}

.h5 {
  font-family: "montserrat-bold";
  font-size: 24px;
  line-height: 36px;
  text-align: left;
}

.buttonAddFounds {
  text-align: center;
  color: #163969;
  font-size: 16px;
  font-family: "montserrat-semibold";
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  word-wrap: break-word;
}

.modalTextAddFounds {
  color: #302e2e;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.table th {
  background-color: #f2f2f4;
  /* border: 1px solid #ccc; */
}

@media (max-width: 1150px) {
  .card-title {
    font-size: 14px;
  }

  .card-mxn {
    font-size: 20px;
  }

  .usd-balance {
    font-size: 12px;
  }

  .content-balance {
    font-size: 18px;
  }

  .blocked-amount {
    font-size: 12px;
  }

  .blocked-amount-2 {
    font-size: 14px;
  }

  .buttonAddFounds {
    font-size: 14px;
  }

  .circle-sheet {
    display: none;
  }
}

@media (max-width: 1250px) {
  .circle-sheet {
    width: 155px;
    height: 170px;
    padding-left: 17px;
    padding-right: 40px;
    right: -50px;
    top: -5px;
  }
}
</style>
